import { useEffect, useState } from "react";
import { Table, Tag, Typography, Space, Input, Row, Col, Button, Tooltip, message } from "antd";
import PageWrapper from "../../utils/PageWrapper";
import PageTitle from "../../utils/PageTitle";
import { Bell, Mail, MailOpen } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "../../layout/auth";
import moment from "moment";
import "moment/locale/es-mx";
import axios from "axios";

moment.locale("es-mx");

export default function Notificaciones(props) {
  const auth = useAuth();

  const [allNotifications, setAllNotifications] = useState([]);
  const [search, setSearch] = useState("");
  const [filteredNotifications, setFilteredNotifications] = useState([]);

  const fetchNotifications = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/notificaciones/porUsuario/${auth.UID}?u=${auth.UID}`);
      const data = await response.json();
      setAllNotifications(data);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, [auth.UID]);

  useEffect(() => {
    if (search) {
      const filtered = allNotifications.filter((notification) => {
        return (
          notification?.Mensaje?.toString().toLowerCase().includes(search.toLowerCase()) ||
          notification?.TargetURL?.toString().toLowerCase().includes(search.toLowerCase())
        );
      });
      setFilteredNotifications(filtered);
    } else {
      setFilteredNotifications(allNotifications);
    }
  }, [search, allNotifications]);

  const handleMarkAs = (notificationId, status) => {
    const url = `${process.env.REACT_APP_API_URL}/notificaciones/${notificationId}/${status === 1 ? "leida" : "noLeida"}`;
    axios
      .put(url)
      .then(() => {
        message.success(`Notificación marcada como ${status === 1 ? "leída" : "no leída"}`);
        const updatedNotifications = allNotifications.map((n) => {
          if (n.NotificacionID === notificationId) {
            return { ...n, Estado: status };
          }
          return n;
        });
        setAllNotifications(updatedNotifications);
      })
      .catch(() => {
        message.error("Error al actualizar la notificación");
      });
  };

  const columns = [
    {
      title: "Fecha",
      dataIndex: "Created_At",
      key: "Created_At",
      render: (text) => (
        <Space>
          <span>{moment(text, "YYYY-MM-DD").format("DD/MM/YYYY")}</span>
          <span>{moment(text, "YYYY-MM-DD").fromNow()}</span>
        </Space>
      ),
    },
    {
      title: "Mensaje",
      dataIndex: "Mensaje",
      key: "Mensaje",
    },
    {
      title: "Estado",
      dataIndex: "Estado",
      key: "Estado",
      width: 100,
      render: (text) => {
        if (text === 0) {
          return <Tag color="green">Nueva</Tag>;
        } else if (text === 1) {
          return <span className="subtle-text">Leída</span>;
        }
      },
    },
    {
      title: "Acciones",
      key: "acciones",
      width: 100,
      render: (text, record) => (
        <Space size="middle">
          {record.Estado === 0 ? (
            <Tooltip title="Marcar como leída">
              <Button icon={<MailOpen size={16} color="#8c8c8c" />} onClick={() => handleMarkAs(record.NotificacionID, 1)} type="ghost" />
            </Tooltip>
          ) : (
            <Tooltip title="Marcar como no leída">
              <Button icon={<Mail size={16} color="#1890ff" />} onClick={() => handleMarkAs(record.NotificacionID, 0)} type="ghost" />
            </Tooltip>
          )}
          <Link to={record.TargetURL}>
            <Button>Ver</Button>
          </Link>
        </Space>
      ),
    },
  ];

  const rowClassName = (record) => {
    return record.Estado === 0 ? "unread-notification-row" : "read-notification-row";
  };

  return (
    <PageWrapper className="notificaciones-main-card">
      <PageTitle icon={<Bell />} title="Todas las notificaciones" />
      <div
        style={{
          padding: "16px",
          background: "rgba(249, 250, 251, 0.8)",
          borderRadius: "12px",
          border: "1px solid rgba(229, 231, 235, 0.6)",
          boxShadow: "0 4px 16px rgba(0, 0, 0, 0.05)",
          marginBottom: "24px",
        }}
      >
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <Input.Search
              placeholder="Buscar notificación"
              onSearch={(value) => {
                setSearch(value);
              }}
              enterButton="Buscar"
              size="large"
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ textAlign: "right" }}>
            {/* No action buttons for now */}
          </Col>
        </Row>
      </div>
      <Table
        columns={columns}
        dataSource={search ? filteredNotifications : allNotifications}
        size="middle"
        style={{ width: "100%" }}
        rowKey="NotificacionID"
        rowClassName={rowClassName}
      />
    </PageWrapper>
  );
}